module.exports = __webpack_public_path__ + "static/media/step4.d8365d37.jpeg";